import type { AxiosRequestConfig } from 'axios';

import { datalabHttp } from '@dbl/services/common';

import type {
  ISearchUsersRequest,
  IUserSearchData,
  TSearchUserListData,
} from './types';

/**
 * 获取当前登录用户信息（权限/展示）。
 *
 * 接口：`GET /api/v1/permission/userInfo`；存量：`getUserInfo`。
 */
export const getUserInfo: () => Promise<unknown> = () =>
  datalabHttp('/api/v1/permission/userInfo', {
    method: 'get',
  });

/**
 * 按用户名搜索 datalab 用户（通用，可供访问设置、选人下拉等复用）。
 *
 * wire 为 `IUserSearchData`；`formatData` 仅返回 `list` → `TSearchUserListData`。
 *
 * 接口：`GET /api/v1/datalab/user`；存量：`getShareEditUserList`。
 */
export function searchUsers(
  params: ISearchUsersRequest,
): Promise<TSearchUserListData> {
  const {
    user_name: userName,
    page = 1,
    page_size: pageSize = '10',
  } = params;
  const url = `/api/v1/datalab/user?user_name=${userName}&page=${page}&page_size=${pageSize}`;
  return datalabHttp({
    url,
    method: 'get',
    formatData: (data: IUserSearchData): TSearchUserListData => data.list ?? [],
  });
}

/**
 * 获取联系人信息（报表创建/编辑页展示创建人）。
 *
 * 接口：`GET /api/v1/datalab/user_concat`；存量：`getContactInfo`。
 */
export function getContactInfo(): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/user_concat',
    method: 'get',
    useCustomTips: true,
  });
}
